"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var useField_1 = require("../../hooks/useField");
var RadioSwitch_1 = __importDefault(require("../RadioSwitch"));
var ErrorMessage_1 = __importDefault(require("./common/ErrorMessage"));
var RadioField = function (props) {
    var options = props.options, name = props.name, variant = props.variant;
    var _a = (0, useField_1.useField)(props), field = _a[0], meta = _a[1];
    var onChange = field.onChange, onBlur = field.onBlur;
    var error = meta.error, touched = meta.touched, value = meta.value;
    var showError = Boolean(error && touched);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(RadioSwitch_1.default, __assign({}, { onChange: onChange, onBlur: onBlur, value: value, name: name, options: options, variant: variant })),
        showError ? react_1.default.createElement(ErrorMessage_1.default, { children: error }) : null));
};
exports.default = RadioField;
